import { Component, OnInit, OnDestroy } from '@angular/core';
import { AlertService } from 'projects/app-misc/src/app/modules/alert/data/alert.service';
import { ProjectAlert } from 'projects/app-misc/src/app/modules/alert/data/alert';
import { WsService } from 'projects/app-misc/src/app/modules/data/ws.service';
import { WsUpdateResponce } from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';

@Component({
    selector: 'app-alerts-column',
    templateUrl: './alerts-column.component.html',
    styleUrls: ['./alerts-column.component.scss']
})
@RxJSUnsubscribe
export class AlertsColumnComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

    alerts: ProjectAlert[];

    loadingSpinner: boolean;

  wsSub: Subscription;
    constructor(
        protected alertService: AlertService,
        protected wsService: WsService
    ) { }

    ngOnInit() {
        this.loadingSpinner = true;

        this.getAlerts();

        this.wsSubToAlerts();

    }

    getAlerts() {

        this.alertService.getActiveAlerts().subscribe(alerts => {
            this.alerts = alerts.content;
            this.loadingSpinner = false;
        }, error => {
            this.loadingSpinner = false;
        })
    }

    wsSubToAlerts() {
    this.wsSub = this.wsService
            .listenUntilDestroyed<WsUpdateResponce<ProjectAlert>>('/topic/update/model.notification.alert.ProjectAlert', this)
            .pipe(
                debounceTime(2000)
            )
            .subscribe(updateInfo => {
                this.getAlerts();
            })
    }

    ngOnDestroy() {
    if(this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }

}
